import BooleanInput from './BooleanInput';

export default BooleanInput;
